import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const token = localStorage.getItem("token");

  // ยังไม่ login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // login แล้ว → ไปหน้าลูก
  return <Outlet />;
};

export default ProtectedRoute;
